import React, { useEffect, useRef } from 'react';
import { ReferenceField, SelectField, Datagrid, TextField } from 'react-admin';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import EditButtonWithOnClick from '../../../core/components/EditButtonWithOnClick';

const preferredMethodLookups = [
  { id: 0, name: 'Wire' },
  { id: 1, name: 'Check' }
];

const styles = () => ({
  statusColumnStyle: {
    width: '68px'
  },
  label: {
    color: '#424242',
    fontSize: '14px',
    display: 'inline-block',
    paddingBottom: '10px'
  },
  expandLabel: {
    color: '#757575',
    fontSize: '14px',
    display: 'inline-block',
    transform: 'translateY(-10px)'
  },
  progress: {
    display: 'flex',
    justifyContent: 'center'
  },
  editButtonColumnStyle: {
    width: '24px'
  },
  editButton: {
    color: '#757575',
    width: '24px',
    padding: '6px 0',
    '& span': {
      paddingRight: 0
    }
  }
});

const DisplayFundRecord = props => {
  if (props.record.fundId === '*') {
    return (
      <span id="Fund" className="MuiTypography-root MuiTypography-body2">
        Use for All Funds
      </span>
    );
  }
  return (
    <ReferenceField
      label="Fund"
      source="fundId"
      reference="funds"
      sortBy="name"
      sortable={false}
      link={false}
      {...props}
    >
      <TextField source="name" sortable={false} id="Fund" />
    </ReferenceField>
  );
};

const DetailsColumn = props => {
  const { record, handleOpen, classes } = props;
  return (
    <EditButtonWithOnClick
      id="edit button"
      label=""
      className={classes.editButton}
      headerClassName={classes.editButtonColumnStyle}
      onClick={() => handleOpen(record)}
    />
  );
};

const WireInstructionsDatagrid = props => {
  const {
    classes,
    expand,
    handleOpen,
    permissions,
    hasEditPermission,
    setDataAvailable,
    ...datagridProps
  } = props;
  const hasEditWireInstructionPermission = permissions.includes(
    'AUTH_EDIT_WIRE_INSTRUCTION'
  );
  const dataAvailableMemo = useRef(false);

  const dataAvailable = props.total && props.total > 0;

  useEffect(() => {
    if (dataAvailable !== dataAvailableMemo.current) {
      dataAvailableMemo.current = dataAvailable;
      setDataAvailable(dataAvailable);
    }
  }, [dataAvailable, setDataAvailable]);

  if (dataAvailable) {
    return (
      <>
        <Datagrid {...datagridProps}>
          <DisplayFundRecord label="Fund" />
          <SelectField
            id="wireinstruction transfer"
            label="Transfer Method"
            source="preferredFlag"
            choices={preferredMethodLookups}
            sortable
          />
          <TextField
            label="Description"
            source="wireDescription"
            sortable
            id="wireinstruction description"
          />
          <TextField
            id="wireinstruction beneficiary"
            label="Beneficiary Name"
            source="beneficiaryName"
            sortable
          />
          {hasEditPermission && hasEditWireInstructionPermission && (
            <DetailsColumn
              label=" "
              handleOpen={handleOpen}
              classes={classes}
            />
          )}
        </Datagrid>
      </>
    );
  } else if (props.loaded) {
    return (
      <span className={expand ? classes.expandLabel : classes.label}>
        There are no related Wire Instructions to be displayed
      </span>
    );
  } else {
    return (
      <div className={classes.progress}>
        <CircularProgress />
      </div>
    );
  }
};

export default withStyles(styles)(WireInstructionsDatagrid);
